import { Match } from "effect";
import { INTERNAL_HTTP_MESSAGE } from "@workerstation/shared/errors/http";
import type { HistoryClientFailure } from "./model.ts";

export const historyFailureMessage = (failure: HistoryClientFailure): string => Match.value(failure).pipe(
  Match.tag("HistoryValidationError", value => value.message),
  Match.tag("HistoryNotFoundError", value => value.message),
  Match.tag("HistoryConflictError", value => value.message),
  Match.tag("HistoryMethodNotAllowedError", value => value.message),
  Match.tag("ResourceStorageError", () => INTERNAL_HTTP_MESSAGE),
  Match.exhaustive
);
